"use client";
import * as React from "react";
import {useMemo, useState} from "react";
import {OpenFilterCarouselContext} from "@/context/product-params-context";
import {useCookies} from "react-cookie";
import {defaultProductParams} from "@/lib/products";
import useSearchLogic from "@/hooks/useSearchLogic";
import ProductFilters from "./products-filters";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import {Box, Card, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {useSearchParams} from "next/navigation";
import FaIcon from "@/components/utilities/fa-icon";
import {useProductsFilters} from "@/hooks/useProductsFilters";

export default function ProductFiltersColumn() {
    const searchParams = useSearchParams();
    const theme = useTheme();
    const {totalSelectedItemsCount} = useSearchLogic();
    const {updateFilters} = useProductsFilters();

    const [cookie, setCookie] = useCookies(["OpenFilterCarousel"]);
    const [openFilterCarousel, setOpenFilterCarouselRaw] = useState<string>(
        cookie.OpenFilterCarousel
    );

    const query = useMemo(() => {
        return Object.fromEntries(new URLSearchParams(searchParams.toString()).entries());
    }, [searchParams]);


    const trigger = useScrollTrigger({
        target: typeof window !== "undefined" ? window : undefined,
    });

    const handleSetOpenFilterCarousel = (value: string) => {
        setOpenFilterCarouselRaw(value);
        setCookie("OpenFilterCarousel", value);
    };


    return (
        <Box sx = {{position: "sticky", top: trigger ? 88 : 136}} >
            <OpenFilterCarouselContext.Provider value = {{openFilterCarousel, setOpenFilterCarousel: handleSetOpenFilterCarousel}} >

                <Card id="products-filter-box" sx={{ pt: 3 }}>
                    <Box display = "flex" justifyContent = "space-between" alignItems = "center" px = {3} pb = {3} >
                        <Box
                            display = "flex"
                            alignItems = "center"
                            gap = {1}
                        >
                            <FaIcon fontSize = {18} faIcon = "fa-filter" />

                            <Typography fontSize = {18} fontWeight = {500} >
                                فیلترها
                            </Typography >
                        </Box >

                        {totalSelectedItemsCount > 0 && (
                            <Typography
                                onClick = {() => {
                                    updateFilters({
                                        ...defaultProductParams,
                                        isExists: query.isExists === "true",
                                    });

                                }}
                                fontSize = {14}
                                fontWeight = {400}
                                sx = {{cursor: "pointer"}}
                                color = {theme.palette.primary.main}
                            >
                                حذف فیلترها
                            </Typography >
                        )}
                    </Box >
                    <ProductFilters />

                </Card >

            </OpenFilterCarouselContext.Provider >
        </Box >
    );
}
